import { RateStatusCd } from "@xpo-ltl/sdk-common";
import {
  CorrectionsAccessorialRespModel,
  CorrectionsAdvanceScacRespModel,
  CorrectionsCashPaidByShipperRespModel,
  CorrectionsCommoditiesRespModel,
  CorrectionsCustomerRespModel,
  CorrectionsDiscountAmountRespModel,
  CorrectionsSicRespModel,
  CorrectionsBeyondScacRespModel,
  CorrectionsSupplementalReferencesRespModel,
  CorrectionsChargeCodeRespModel,
  CorrectionsCodAmountRespModel,
  CorrectionsWeightLineRespModel,
  CorrectionsPricingAgreementRespModel,
} from "../corrections-detail.model";
import { BillClassEnum } from "@shared/enums/common-data/bill-class.enum";

export class CorrectionsPreviewRatesModel {
  accesorials: CorrectionsAccessorialRespModel[];
  authorityRemarks: string;
  billTo: CorrectionsCustomerRespModel;
  cashPaid: CorrectionsCashPaidByShipperRespModel;
  chargeCode: CorrectionsChargeCodeRespModel;
  codAmount: CorrectionsCodAmountRespModel;
  commodities: CorrectionsCommoditiesRespModel[];
  consignee: CorrectionsCustomerRespModel;
  customInBond: string;
  discounts: CorrectionsDiscountAmountRespModel;
  pickupDate: string;
  pricingRulesetAfterChanges: CorrectionsPricingAgreementRespModel;
  rateStatusCd: RateStatusCd;
  revenues: CorrectionsPreviewRevenuesModel;
  shipmentRemarks: string;
  shipper: CorrectionsCustomerRespModel;
  sic: CorrectionsSicRespModel;
  totals: CorrectionsPreviewTotalsModel;
  weightLine: CorrectionsWeightLineRespModel;
}

export class CorrectionsPreviewRatesContentDetailsModel {
  authorityRemarks?: string;
  billClass?: BillClassEnum;
  billingRemarks?: string;
  cashPaid?: CorrectionsCashPaidByShipperRespModel;
  childProNbrs?: string[];
  customInBond?: string;
  parentProNbr?: string;
  pricingRulesetAfterChanges?: CorrectionsPricingAgreementRespModel;
  pricingRulesetBeforeChanges?: CorrectionsPricingAgreementRespModel;
  route?: CorrectionsPreviewRatesRouteModel;
  shipmentRemarks?: string;
  supplementalReferences?: CorrectionsSupplementalReferencesRespModel;
  cnwyRevenue?:  number | string;
}

export class CorrectionsPreviewRatesRouteModel {
  advanceScac?: CorrectionsAdvanceScacRespModel;
  beyondScac?: CorrectionsBeyondScacRespModel;
}

export class CorrectionsPreviewRevenuesModel {
  totalRevenue: number;
  advanceRevenue: number;
  beyondRevenue: number;
}
export class CorrectionsPreviewTotalsModel {
  totalPcs: number;
  totalWeight: number;
  totalCharges: number;
  totalPercentage?: number;
}
